/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import _ from 'lodash'
import React from 'react'
import r from '../../../util/Renderer'
import { MonthlyReservations, ReservationDetail } from '../../organisms/reservations'
import { dateToParam, dateToStringDateMonth } from '../../../util/DateString'
import ReservationAction from '../../../action/reservation'
import { NavigationDrawer, ToolbarDateNavigation } from 'ui-library/dist/external/components'

function ReservationCalendarView(props) {
  const date = props.monthly.date

  let prevMonth = _.cloneDeep(date)
  prevMonth.setMonth(date.getMonth() - 1, 1)

  let nextMonth = _.cloneDeep(date)
  nextMonth.setMonth(date.getMonth() + 1, 1)

  const paginations = {
    prev: {
      onClick: e => {
        ReservationAction.monthChange(prevMonth)
      }
    },
    next: {
      onClick: e => {
        ReservationAction.monthChange(nextMonth)
      }
    }
  }
  const meta = {
    label: dateToStringDateMonth(date),
    component: ToolbarDateNavigation,
    data: { label: dateToStringDateMonth(date), paginations: paginations }
  }
  const toolbar = { label: '宿泊予約カレンダー', items: props.accountMenu }

  return (
    <div className="receptionist clearfix">
      <NavigationDrawer toolbar={toolbar} navigations={props.navigations} meta={meta} />

      <MonthlyReservations>{props}</MonthlyReservations>

      {r.renderIf(props.state.active)(<ReservationDetail page={`/calendar/${dateToParam(date)}`}>{props}</ReservationDetail>)}
    </div>
  )
}

export default ReservationCalendarView
